import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'
import { isUseCase } from '@/lib/utils'

export const SearchSchema = z.object({
  tab: z.union([z.literal('thresholds'), z.literal('percentage')]).default('thresholds'),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/air-quality/settings/')({
  validateSearch: SearchSchema,
  beforeLoad({ context }) {
    if (!isUseCase(UseCase.AIR_QUALITY)) {
      throw redirect({
        to: '/403',
        search: { reason: 'wrongUseCase' },
      })
    }

    if (!context.user?.hasPermission(Permission.COMPANY_SETTINGS)) {
      throw redirect({
        to: '/403',
      })
    }
  },
  pendingComponent: PendingComponent,
})
